import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=6c95f788"
import script from "../../../controllers/custom/subject/subject-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/subject/subject-list.js?vue&type=script&lang=js&external"
import style0 from "./SubjectList.vue?vue&type=style&index=0&id=6c95f788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports